import React from 'react';
import { STAIRS_TEXTURE_MAP } from '../configuratorConstants';

const StairsRenderer = ({ module, scale }) => {
    const width = module.width * scale;
    const height = module.height * scale;
    const StairsTexture = STAIRS_TEXTURE_MAP[module.templateId];

    if (!StairsTexture) {
        return (
            <text x={width / 2} y={height / 2} fill="red" textAnchor="middle" fontSize={12 / (scale / 50)}>
                Texture not found for "{module.templateId}"
            </text>
        );
    }
    
    // --- ИСПРАВЛЕНИЕ ---
    // Базовый поворот необходим, чтобы текстура лестницы правильно 
    // располагалась внутри прямоугольника модуля (вдоль длинной стороны).
    const baseRotation = 90;
    
    // Получаем текущий угол поворота самого модуля на холсте.
    const moduleRotation = module.rotation || 0;
    
    // Суммируем базовый поворот и поворот модуля, чтобы текстура 
    // вращалась вместе с модулем.
    const totalRotation = baseRotation + moduleRotation;
    
    // Применяем итоговый угол поворота к группе с текстурой.
    const transform = `rotate(${totalRotation} ${width / 2} ${height / 2})`;
    // --- КОНЕЦ ИСПРАВЛЕНИЯ ---

    // Так как мы поворачиваем текстуру на 90 градусов, ее ширина и высота
    // меняются местами относительно размеров модуля.
    const textureWidth = height;
    const textureHeight = width;
    
    // Центрируем текстуру внутри модуля после "поворота".
    const textureX = (width - textureWidth) / 2;
    const textureY = (height - textureHeight) / 2;

    const aspectRatio = 'xMidYMid meet';

    return (
        <g style={{ pointerEvents: 'none' }} transform={transform}>
            <StairsTexture 
                x={textureX} y={textureY}
                width={textureWidth}
                height={textureHeight}
                preserveAspectRatio={aspectRatio}
            />
        </g>
    );
};

export default React.memo(StairsRenderer);